var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 60,
    viewBox: "0 0 140 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1887_2351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7925 13.533V46.4677V13.533ZM53.1014 13.533V35.9524V13.533ZM64.4103 13.533V46.4677V13.533ZM75.7193 13.533V20.0802V13.533ZM87.2266 24.0483V46.4677V24.0483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7925 13.533V46.4677M53.1014 13.533V35.9524M64.4103 13.533V46.4677M75.7193 13.533V20.0802M87.2266 24.0483V46.4677",
    stroke: "white",
    strokeWidth: 6.94408
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7192 24.0483V46.4678V24.0483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7192 24.0483V46.4678",
    stroke: "white",
    strokeWidth: 6.94408
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7544 16.8066H102.007H83.7544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7544 16.8066H102.007",
    stroke: "white",
    strokeWidth: 6.54727
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1887_2351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.6871,
    height: 32.9348,
    fill: "white",
    transform: "translate(38.3203 13.5327)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.094b50e46466c87ed8dff859a89bf207.svg";
export { ForwardRef as ReactComponent };